// extracted by mini-css-extract-plugin
export default {"carouselPics":"CarouselMain_carouselPics__v+I-P"};